import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignLanguageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sign_language"}/>
}
